// extracted by mini-css-extract-plugin
export var mcpAlerts = "mcp-alerts_QkCWUxYWiqsYwKnycidp";
export var mcpAlertsTable = "mcp-alerts__table_GGnIveG6B3hSk9Ubd5W3";
export var mcpAlertsTableCell = "mcp-alerts__table-cell_bO7LwzpgKKBd4aT4WBjw";
export var mcpAlertsTableRow = "mcp-alerts__table-row_nbF4HENj783CtvRVPZno";